// import React from "react";
// import { Box } from "@chakra-ui/react";

// const Container = () => {
//   return <Box>Container</Box>;
// };

// export default Container;
import React, { useEffect, useState } from "react";
import { Box, Skeleton } from "@chakra-ui/react";

const Container = ({ children, sx, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an async action, after which the loading state will be false
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  const containerStyle = {
    margin: "120px auto",
    padding: "1rem 2rem",
    width: "100%",
    maxWidth: { base: "100%", md: "1350px", lg: "1350px" },
    // border: "1px solid #ccc",
    ...sx,
  };

  return (
    <Skeleton isLoaded={!isLoading}>
      <Box sx={containerStyle} {...props}>
        {children}
      </Box>
    </Skeleton>
  );
};

export default Container;
